import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-998a60ca"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("textarea", { id: "textarea" }, null, -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_FloatingTool = _resolveComponent("FloatingTool")!

  return (_openBlock(), _createBlock(_component_FloatingTool, {
    title: _ctx.$t('toolbar.notepad'),
    "tool-name": 'notepad',
    width: 330,
    height: 400,
    "bottom-text": _ctx.characterCount,
    onSectionChange: _ctx.handleSectionChange
  }, {
    default: _withCtx(() => [
      _hoisted_1
    ]),
    _: 1
  }, 8, ["title", "bottom-text", "onSectionChange"]))
}